import FormRow from 'Components/FormRow';
import FormSection from 'Components/FormSection';
import InputHandler from 'Components/InputHandler';
import { IFormContext, withFormContext } from 'Containers/FormContextHandler';
import * as React from 'react';

const SymptomsDetailsForm = ({ editing, formData }: IFormContext): React.JSX.Element => {
  return (
    <React.Fragment>
      <FormSection>
        <FormRow title="diagnosis.ninmt.symptomsDetails.symptomsDetails">
          <InputHandler
            type="TextArea"
            name="symptomsDetails"
            formData={formData}
            editing={!!editing}
            placeholder="diagnosis.ninmt.symptomsDetails.symptomsDetailsPlaceholder"
          />
        </FormRow>
      </FormSection>
    </React.Fragment>
  );
};

export default withFormContext(SymptomsDetailsForm);
